export const WHATSAPP_NUMBER = "919150035559";
export const PHONE_DISPLAY = "+91 91500 35559";
export const PHONE_TEL = "+919150035559";
export const EMAIL = "info@sanggavais.in";
export const ADDRESS = "S.No. 89/2D1, 4th Floor, Pearl House Valluvar Salai, Ramapuram, Chennai – 600089";

export function buildWhatsappUrl(message) {
  const encoded = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encoded}`;
}

export function buildEnquiryMessage({ name, phone, requirement, message, project }) {
  const lines = [
    "Hello, I'm interested in your projects.",
    "",
    `Name: ${name}`,
    `Phone: ${phone}`,
  ];
  if (project) lines.push(`Project: ${project}`);
  if (requirement) lines.push(`Requirement: ${requirement}`);
  if (message) lines.push(`Message: ${message}`);
  return lines.join("\n");
}
